










import { Prop, Component, Vue } from "vue-property-decorator";
import TextInput from "@/basics/inputs/TextInput.vue";
import CButton from "@/basics/buttons/CButton.vue";

@Component({
  components: { TextInput, CButton }
})
export default class LoginInput extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  company!: string;
  username: string = process.env.VUE_APP_DEFAULT_USERNAME || "";
  password: string = process.env.VUE_APP_DEFAULT_PASSWORD || "";

  get isEmpty() {
    return !this.company || !this.username || !this.password;
  }

  login() {
    const { company, username, password } = this;
    this.$emit("login", {
      company,
      username,
      password
    });
  }
}
